import useDefinedContext from "hooks/useDefinedContext";
import ShowMoreActivityContext from "../contexts/ShowMoreActivityContext";

function useShowMoreActivity() {
  return useDefinedContext(ShowMoreActivityContext);
}
export default useShowMoreActivity;
